import { usePage } from '@inertiajs/vue3';
import BrowserMediaPermissionManager from './BrowserMediaPermissionManager';

export default async function requestPhoto(is_login: Boolean) {
	//@ts-ignore
	const title = is_login
		? usePage().props.login_face_modal_settings.welcomeMessage
		: usePage().props.logout_face_modal_settings.welcomeMessage;
	//@ts-ignore
	const swalSettings = {
		//@ts-ignore
		title: title,
		allowOutsideClick: false,
		allowEscapeKey: false,
		confirmButtonText: is_login
			? 'Usar webcam'
			: 'Iniciar processo de captura da foto',
		showLoaderOnConfirm: true,
		cancelButtonText: 'Cancelar',
		showCancelButton: false,
		customClass: 'login-logout-container',
		denyButtonText: 'Sair da plataforma',
		showDenyButton: is_login,
		denyButtonColor: '#DD6B55',
	};
	//@ts-ignore
	const modalSettings = is_login
		? usePage().props.login_face_modal_settings
		: usePage().props.logout_face_modal_settings;

    let browser_has_camera_permission = await BrowserMediaPermissionManager.browserHasCameraPermission();

    if (!browser_has_camera_permission) {
        await Swal.fire({
            icon: "warning",
            title: "Permissão para acessar a câmera",
            text: "Você precisa permitir que o navegador acesse a câmera para bater a foto.",
            allowOutsideClick: false,
            confirmButtonText: 'Pedir permissão'
        }).then(async (result) => {
            try {
                await BrowserMediaPermissionManager.requestBrowserMediaPermissions()

                showRequestPhotoModal(swalSettings, modalSettings, is_login)
            } catch (e) {
                await Swal.fire({
                    icon: "error",
                    title: "Erro ao acessar câmera",
                    text: "Não foi possível acessar a câmera ou pedir a permissão. Por favor, verifique nas configurações do seu navegador se o acesso à câmera está liberado. Além disso, certifique-se de que nenhum outro aplicativo esteja utilizando a câmera no momento.",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                })
            }
        });

        return;
    }

    showRequestPhotoModal(swalSettings, modalSettings, is_login)
}

function showRequestPhotoModal(swalSettings, modalSettings, is_login) {
    //@ts-ignore
    window
        .requestPhoto(
            swalSettings,
            modalSettings,
            window.camera_settings,
            is_login
        )
        .then((msg) => {
            console.log('login success', msg);
        })
        .catch((error) => {
            console.log('login error', error);
        });
}
